import { ColumnDef } from "@tanstack/react-table";
import i18next from "i18next";

// EN-3346: columns for this ticket only. Ward/personal, Created by and Manage
// actions arrive with personalised protocols and are intentionally excluded.
export const protocolActionsTableColumns: ColumnDef<any, string>[] = [
  {
    accessorKey: "action",
    header: () => i18next.t("patientPage_columns_action"),
    cell: (info) => info.renderValue(),
    enableSorting: false,
    size: 200,
  },
  {
    accessorKey: "frequency",
    header: () => i18next.t("patientPage_columns_frequency"),
    cell: (info) => info.renderValue(),
    enableSorting: false,
    size: 150,
  },
  {
    accessorKey: "startDate",
    header: () => i18next.t("patientPage_columns_start_date"),
    cell: (info) => info.renderValue(),
    enableSorting: false,
    size: 180,
  },
  {
    accessorKey: "lastCompleted",
    header: () => i18next.t("patientPage_columns_last_completed"),
    cell: (info) => info.renderValue(),
    enableSorting: false,
    size: 180,
  },
  {
    accessorKey: "nextActionDue",
    header: () => i18next.t("patientPage_columns_next_action_due"),
    cell: (info) => info.renderValue(),
    enableSorting: false,
    size: 180,
  },
];
